import { render, staticRenderFns } from "./EmailTransfer.vue?vue&type=template&id=38912b4e&scoped=true&"
import script from "./EmailTransfer.vue?vue&type=script&lang=ts&"
export * from "./EmailTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTransfer.vue?vue&type=style&index=0&id=38912b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38912b4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
